import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditEmailCredential {
    data: {
        title: string
        fromEmail?: string
        host?: string
        port?: string
        username?: string
        password?: string
    }
    id: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IListState {
    status: string
    data: any
    errors: any
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editSlice = createSlice({
    name: 'email-credential/edit',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditEmailCredential>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editActions = editSlice.actions
export default editSlice.reducer
